import { z } from 'zod'

export const CompanyContactSchema = z.union([
  z.object({
    office_name: z.string().nullish(),
    contact_name: z.string(),
    contact_title: z.string(),
    address_1: z.string(),
    address_2: z.string(),
    city: z.string(),
    state: z.string(),
    zip_code: z.string(),
    phone: z.string(),
    fax: z.string(),
    email: z.string(),
  }),
  z.object({
    office_name: z.string(),
    contact_name: z.string(),
    contact_title: z.string(),
    address_1: z.string(),
    address_2: z.string(),
    city: z.string(),
    state: z.string(),
    zip_code: z.string(),
    phone: z.string(),
    fax: z.string(),
    email: z.string(),
  }),
])

export const CompanySchema = z.object({
  id: z.number(),
  date: z.string(),
  date_gmt: z.string(),
  guid: z.object({ rendered: z.string() }),
  modified: z.string(),
  modified_gmt: z.string(),
  slug: z.string(),
  status: z.string(),
  type: z.string(),
  link: z.string(),
  title: z.object({ rendered: z.string() }),
  template: z.string(),
  // company_type: z.array(z.number()),
  acf: z.object({
    bap_company: z.boolean(),
    yp_company: z.boolean(),
    website: z.string(),
    bap_description: z.string(),
    bap_contact_info: z.array(CompanyContactSchema).or(z.literal(false)).nullish(),
    bap_categories: z.array(z.number()).or(z.boolean()),
    bap_type: z.union([z.string(), z.boolean()]),
    yp_description: z.string(),
    yp_contact_info: z.array(CompanyContactSchema).or(z.literal(false)).nullish(),
    yp_other_office_text: z.string(),
    yp_categories: z.array(z.number()).or(z.boolean()),
    yp_service_area: z.string(),
  }),
  _links: z.object({
    self: z.array(z.object({ href: z.string() })),
    collection: z.array(z.object({ href: z.string() })),
    about: z.array(z.object({ href: z.string() })),
    'acf:term': z
      .array(
        z.object({
          embeddable: z.boolean(),
          taxonomy: z.string(),
          href: z.string(),
        })
      )
      .nullish(),
    'wp:attachment': z.array(z.object({ href: z.string() })),
    'wp:term': z.array(
      z.object({
        taxonomy: z.string(),
        embeddable: z.boolean(),
        href: z.string(),
      })
    ),
    curies: z.array(z.object({ name: z.string(), href: z.string(), templated: z.boolean() })),
  }),
})
export const CompaniesSchema = z.array(CompanySchema)

export const TermSchema = z.object({
  id: z.number(),
  count: z.number(),
  description: z.string(),
  link: z.string(),
  name: z.string(),
  slug: z.string(),
  taxonomy: z.string(),
  meta: z.array(z.unknown()),
  acf: z.array(z.unknown()),
  _links: z.object({
    self: z.array(z.object({ href: z.string() })),
    collection: z.array(z.object({ href: z.string() })),
    about: z.array(z.object({ href: z.string() })),
    'wp:post_type': z.array(z.object({ href: z.string() })),
    curies: z.array(z.object({ name: z.string(), href: z.string(), templated: z.boolean() })),
  }),
})

export const getTermsSchema = z.array(TermSchema)
export type getTerms = z.infer<typeof getTermsSchema>
